import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-warning-icon",
  props: {
    color: {
      type: String,
      default: "#FCB017"
    }
  }
};
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["fill"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [
    createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.666748 13.9997H15.3334L8.00008 1.33301L0.666748 13.9997V13.9997ZM8.66675 11.9997H7.33342V10.6663H8.66675V11.9997V11.9997ZM8.66675 9.33301H7.33342V6.66634H8.66675V9.33301V9.33301Z",
      fill: $props.color
    }, null, 8, _hoisted_2)
  ]);
}
const WarningIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  WarningIcon as default
};
//# sourceMappingURL=WarningIcon.vue.es.js.map
